module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/131.70953c26.png";